import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AwaitingCoachPage } from 'pages/awaiting-coach/awaiting-coach';

@NgModule({
    declarations: [AwaitingCoachPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AwaitingCoachPage]
})
export class AwaitingCoachPageModule { }
